module.exports = __webpack_public_path__ + "img/Frente-32-00 off.e9b91528.png";